import BUSD_ABI from "../Contracts/BUSD_ABI.json";
import contractABI from "../Contracts/contract_ABI.json";
import tokenABI from "../Contracts/Token_ABI.json";
import ATMTokenABI from "../Contracts/ATMTokenABI.json";

// Mainnet
const arr = {
  contract: "0x7D648c4ea9932561efceae4F5a2D14B306B35585",
  contractABI: contractABI,
  tokenContract: "0x5B919ACC8eb6E675Ef4849B08B4c0b39ebe782E9",
  tokenABI: tokenABI,
  BUSD: "0x55d398326f99059fF775485246999027B3197955",
  BUSD_ABI: BUSD_ABI,
  ATMToken:"0x55d398326f99059fF775485246999027B3197955",
  ATMTokenABI:ATMTokenABI,
};

////////////////mainnet//////////////////
// const arr = {
//   contract: "0x39b022Cd9d8297A16465daF3BcAE603572a2529b",
//   contractABI: contractABI,
//   BUSD: "0x55d398326f99059fF775485246999027B3197955",
//   BUSD_ABI: BUSD_ABI,
//   ATMToken:"0x55d398326f99059fF775485246999027B3197955",
//   ATMTokenABI:ATMTokenABI,
// };

// Testnet
// const arr = {
//   contract: "0x8c6505eF6F05eD18637f4E0bad1e26BEd6E41C87",
//   contractABI: contractABI,
//   tokenContract: "0xad8d380617C010B7eCe8B7A7b32BF147E1525F18",
//   tokenABI: tokenABI,
//   BUSD: "0xa97f6c3e422a00a7a5B363340DF431b7d5412483",
//   BUSD_ABI: BUSD_ABI,
//   ATMToken:"0x771d76a2F35b8809119cc712cD9010A19164DFad",
//   ATMTokenABI:ATMTokenABI,
// };

// Testnet
// const arr = {
//   contract: "0xCE74ecA7E8f5563dC10263311bCCb756b6F3F548",
//   contractABI: contractABI,
//   BUSD: "0x55d398326f99059fF775485246999027B3197955",
//   BUSD_ABI: BUSD_ABI,
//   ATMToken:"0x55d398326f99059fF775485246999027B3197955",
//   ATMTokenABI:ATMTokenABI,
// };


////////////////testnet//////////////////
// const arr = {
//   contract: "0x86b7a3f5179B264122F402f72E5375ca8ce6740C",
//   contractABI: contractABI,
//   BUSD: "0x771d76a2F35b8809119cc712cD9010A19164DFad",
//   BUSD_ABI: BUSD_ABI,//currently using this

//   token: "0x771d76a2F35b8809119cc712cD9010A19164DFad ",
//   tokenABI: tokenABI,
//   ATMToken:"0x771d76a2F35b8809119cc712cD9010A19164DFad",
//   ATMTokenABI:ATMTokenABI,
// };

export const ContractDetails = arr;

// Action creators are generated for each case reducer function

export default ContractDetails;
